// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".call-us-card-container[data-v-f4f9e358]{max-width:374px;min-height:150px;width:100%}.call-us-card-container__status[data-v-f4f9e358]{color:#20a200;padding-left:18px;position:relative}.call-us-card-container__status[data-v-f4f9e358]:before{background-color:#20a200;border-radius:50%;bottom:11px;content:\"\";height:6px;left:3px;position:absolute;width:6px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
